var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 7.81519,
    width: 1.5,
    height: 11.131,
    rx: 0.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7.81519,
    width: 1.5,
    height: 11.131,
    rx: 0.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19328 3.2146H14.8068C15.0829 3.2146 15.3068 3.43846 15.3068 3.7146V4.47588H8.69328V3.7146C8.69328 3.43846 8.91714 3.2146 9.19328 3.2146ZM7.19328 4.47588V3.7146C7.19328 2.61003 8.08871 1.7146 9.19328 1.7146H14.8068C15.9113 1.7146 16.8068 2.61003 16.8068 3.7146V4.47588H18.1052H20.1652C20.6262 4.47588 21 4.84964 21 5.3107C21 5.77176 20.6262 6.14552 20.1652 6.14552H19.1052V21.2854C19.1052 21.8377 18.6575 22.2854 18.1052 22.2854H5.8947C5.34242 22.2854 4.8947 21.8377 4.8947 21.2854V6.14552H3.83482C3.37376 6.14552 3 5.77176 3 5.3107C3 4.84964 3.37376 4.47588 3.83482 4.47588H5.8947H7.19328ZM17.6052 6.14552H6.3947V20.7854H17.6052V6.14552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/DeleteWhite.d6f1a1b0896fe548880b117ff2ba879a.svg";
export { ForwardRef as ReactComponent };